<template>
  <v-card class="pa-4">
    <v-btn absolute top right text icon @click="$emit('close')">
      <v-icon color="grey">mdi-close</v-icon>
    </v-btn>

    <div class="my-6 text-center">
      <h3>Desalienar múltiplos equipamentos</h3>
    </div>

    <div class="text-center mb-4">
      <p>
        Tem certeza que deseja desalienar
        {{ selectedEquipments.length }}
        {{ selectedEquipments.length === 1 ? 'equipamento' : 'equipamentos' }}?
      </p>
    </div>

    <div class="d-flex justify-end mt-4">
      <v-btn class="mr-2" text @click="$emit('close')" :disabled="loading">
        Cancelar
      </v-btn>
      <v-btn
        class="primary-button mr-0"
        depressed
        :loading="loading"
        @click="submit"
      >
        Confirmar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'

export default {
  name: 'DisalienateMultipleDialog',

  props: {
    selectedEquipments: Array,
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
    }
  },
  methods: {
    submit() {
      this.loading = true

      const model = {
        equipmentIds: this.selectedEquipments.map((x) => x.id),
      }

      this.apiService
        .post('equipment/disalienate/multiple', model)
        .then(() => {
          this.loading = false
          this.$toast.success('Os equipamentos selecionados foram desalienados!')
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
